import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { testTrainingSchema } from "features/tests/create/components/_schemas";
import { IFormCreateTestTraining } from "features/tests/create/components/_interfaces";
import TestConfig from "features/tests/create/components/TestConfig";
import AddTestButton from "features/tests/create/components/AddTestButton";
import TestPageTitle from "features/tests/create/components/TestPageTitle";
import useCreateTest from "features/tests/create/hooks/useCreateTest";
import TestPreviewCustomItemsList from "features/tests/create/components/TestPreviewCustomItemsList";
import TestPreviewCustom from "features/tests/create/components/TestPreviewCustom";
import Loading from "shared/ui/Loading";

const CreateTestCustom = () => {
    const methods = useForm<IFormCreateTestTraining>({
        resolver: yupResolver(testTrainingSchema),
    });

    const testForm = useCreateTest({
        type: "customTest",
        setError: methods.setError,
        clearErrors: methods.clearErrors,
    });

    const {
        loading,
        step,
        createTestData,
        errorMessage,
        setErrorMessage,
        successMessage,
        isFormValid,
        submitTest,
    } = testForm;

    useEffect(() => {
        if (Object.keys(methods.formState.errors).length === 0) {
            setErrorMessage("");
        }
    }, [createTestData]);

    if(successMessage) {
        return (
            <>
                <TestPageTitle title="propriu" />
                <Typography>{successMessage}</Typography>
            </>
        );
    }

    if (loading.loading && loading.name === "step") {
        return (
            <>
                <TestPageTitle title="propriu" />
                <Box width="100%">
                    <Loading show={true} />
                </Box>
            </>
        );
    }

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <TestConfig
                        type="customTest"
                        subjects={testForm.subjects}
                        grades={testForm.grades}
                        createTestData={createTestData}
                        setClassroomHandler={testForm.setClassroomHandler}
                        setSelectedStudentsHandler={testForm.setSelectedStudentsHandler}
                        setSelectAllStudentsHandler={testForm.setSelectAllStudentsHandler}
                        handleSelectChange={testForm.handleSelectChange}
                        handleInputChange={testForm.handleInputChange}
                        setSubjectHandler={testForm.setSubjectHandler}
                        setGradeHandler={testForm.setGradeHandler}
                        handleTestStartDate={testForm.handleTestStartDate}
                        loading={loading}
                        errors={methods.formState.errors}
                        tags={testForm.tags}
                    />
                );
            case 2:
                return (
                    <TestPreviewCustomItemsList
                        createTestData={createTestData}
                        setCustomItemsHandler={testForm.setCustomItemsHandler}
                        removeCustomItemHandler={testForm.removeCustomItemHandler}
                        setSelectedCategoryCustomTestHandler={testForm.setSelectedCategoryCustomTestHandler}
                        selectedItems={testForm.items}
                    />
                );

            case 3:
                return (
                    <TestPreviewCustom
                        items={testForm.items}
                        removeCustomItemHandler={testForm.removeCustomItemHandler}
                    />
                );
            default:
                return null;
        }
    }

    return (
        <>
            <TestPageTitle title="propriu" />
            <Box width="100%">
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submitTest)} noValidate>
                        <Box mb={{ xs: 5, md: 3 }}>
                            {renderStepContent()}
                        </Box>
                        {isFormValid && (
                            <AddTestButton
                                errorMessage={errorMessage}
                                hasSteps={true}
                                step={step}
                                totalSteps={3}
                                itemsLength={testForm.items.length}
                                confirmPreviousStep={testForm.confirmPreviousStep}
                            />
                        )}
                    </form>
                </FormProvider>
            </Box>
        </>
    )
}

export default CreateTestCustom;